const investmentDataRooms = (state = {}, action) => {
  switch (action.type) {
    default: return state;
  }
};

export default investmentDataRooms;
